






























import { Vue, Component, Prop } from "vue-property-decorator";
import { StoreProductGroupDetails } from "@/chipply/StoreProductGroupDetails";

@Component({})
export default class GroupProductsHeader extends Vue {
    @Prop({ type: Object })
    groupProductDetails!: StoreProductGroupDetails;
}
